import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getSliceCategories,
  getSliceCategory,
  getSliceSubCategories,
  getSliceSubCategory,
  sliceHasCategories,
  sliceHasSubCategories,
} from '../selectors';
import {
  sliceCategoryChangedCreator,
  sliceSubCategoryChangedCreator,
} from '../actions';
import CategoryPicker from './CategoryPicker';

const Categories = ({
  categories,
  className,
  hasCategories,
  hasSubCategories,
  onCategoryChange,
  onSubCategoryChange,
  selectedCategory,
  selectedSubCategory,
  subCategories,
}) => (hasCategories ? (
  <CategoryPicker
    className={className}
    options={[
      {
        options: categories,
        onChange: onCategoryChange,
        selected: selectedCategory,
      },
      ...(hasSubCategories ? [{
        all: true,
        options: subCategories,
        onChange: onSubCategoryChange,
        selected: selectedSubCategory,
      }] : []),
    ]}
  />
) : null);

Categories.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  hasCategories: PropTypes.bool.isRequired,
  hasSubCategories: PropTypes.bool.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onSubCategoryChange: PropTypes.func.isRequired,
  selectedCategory: PropTypes.string,
  selectedSubCategory: PropTypes.string,
  subCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
};

Categories.defaultProps = {
  className: undefined,
  selectedCategory: undefined,
  selectedSubCategory: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  categories: getSliceCategories(state, sliceId),
  hasCategories: sliceHasCategories(state, sliceId),
  hasSubCategories: sliceHasSubCategories(state, sliceId),
  selectedCategory: getSliceCategory(state, sliceId),
  selectedSubCategory: getSliceSubCategory(state, sliceId),
  subCategories: getSliceSubCategories(state, sliceId),
});

const mapDispatchToProps = (dispatch, { sliceId }) => ({
  onCategoryChange: category => dispatch(sliceCategoryChangedCreator(sliceId, category)),
  onSubCategoryChange: subCategory => dispatch(
    sliceSubCategoryChangedCreator(sliceId, subCategory),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Categories);
